<template>
    <q-dialog ref="dialogRef" square><!-- persistent  @hide="onDialogHide"  sans 'persistent' -->

        <q-card class="q-dialog-plugin">
            <q-card-section>
            <!-- <q-item>
                <q-item-section> -->
                    <q-item-label class="text-body1">Signatures du Statut {{ courseStore().getStatusLabel(status_skey) }}</q-item-label>
                    <q-item-label><small>Course Ref: {{ course.ref }}</small></q-item-label>
                <!-- </q-item-section>
            </q-item> -->
            </q-card-section>

            <q-card-section>

                <div v-show="showSignatureDriver">
                    <ElectroSignature for_role="Chauffeur"
                                    @signed="v => { dataURL_driver = v; handleSignatureRecipient() }" />
                </div>

                <div v-if="showSignatureRecipient">

                    <ElectroSignature for_role="Destinataire"
                                    @signed="v => { is_signed = Boolean(v); dataURL_recipient = v }" />
                </div>


            </q-card-section>

            <q-card-actions align="around">
                <q-btn color="warning" label="Annuler" @click="onDialogCancel" square />

                <q-btn color="positive" label="Valider" @click="onOKClick" square outline
                        :disable=" ! is_signed" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup>
import { open } from "@helpers";
import { useDialogPluginComponent } from 'quasar'
import { ref/* , computed */ } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { courseStore } from "@stores";

import ElectroSignature from '@comp/partials/ElectroSignature.vue'

const props = defineProps({
    course: Object,
    status_skey: String,
})

// defineEmits([
//   // REQUIRED; need to specify some events that your
//   // component will emit through useDialogPluginComponent()
//   ...useDialogPluginComponent.emits
// ])

let showSignatureDriver = ref(true)
let showSignatureRecipient = ref(false)

let loading_driver = ref(true)
let loading_recipient = ref(true)


let is_signed = ref(false)


const handleSignatureRecipient = ()=>{
    showSignatureDriver.value = false
    showSignatureRecipient.value = true
}


let dataURL_driver = null
let dataURL_recipient = null


// const dialogRef = ref(null)

const { dialogRef, onDialogOK, onDialogCancel/* , onDialogHide */ } = useDialogPluginComponent()
// dialogRef      - Vue ref to be applied to QDialog
// onDialogHide   - Function to be used as handler for @hide on QDialog
// onDialogOK     - Function to call to settle dialog with "ok" outcome
//                    example: onDialogOK() - no payload
//                    example: onDialogOK({ /*...*/ }) - with payload
// onDialogCancel - Function to call to settle dialog with "cancel" outcome

// this is part of our example (so not required)
function onOKClick () {

  // on OK, it is REQUIRED to
  // call onDialogOK (with optional payload)
    onDialogOK({signature_driver: dataURL_driver, signature_recipient: dataURL_recipient}) // for store/courses @updateStatus()

  // or with payload: onDialogOK({ ... })
  // ...and it will also hide the dialog automatically
}
</script>